/**
 * SaveButton Component
 *
 * Reusable save button with loading and status states
 * Supports: idle, success, error, partial (some items saved with warnings)
 */

'use client';

import { Typography } from '@/src/shared/ui/typography/Typography';
import type { SaveStatus } from './hooks/useProfileSave';

export interface SaveButtonProps {
  onClick: () => void;
  isLoading: boolean;
  status: SaveStatus;
}

export function SaveButton({ onClick, isLoading, status }: SaveButtonProps) {
  return (
    <div className="flex items-center gap-4">
      {status === 'success' && (
        <Typography variant="body" className="text-green-600">
          ✓ Profile saved successfully!
        </Typography>
      )}
      {status === 'partial' && (
        <Typography variant="body" className="text-amber-600">
          ⚠ Saved with warnings - check location settings
        </Typography>
      )}
      {status === 'error' && (
        <Typography variant="body" className="text-red-600">
          ✗ Please fix the errors above and try again
        </Typography>
      )}
      <button
        onClick={onClick}
        disabled={isLoading}
        className="px-8 py-3 bg-accent-primary text-white rounded-full hover:bg-accent-primary/90 transition-colors disabled:opacity-50 disabled:cursor-not-allowed"
      >
        <Typography variant="body" weight="semibold">
          {isLoading ? 'Saving...' : 'Save Changes'}
        </Typography>
      </button>
    </div>
  );
}
